import { flipCoin, rollDice, type ToolOutcome } from "../../engine/tools";
import { useInstant } from "../../hooks/useInstant";
import { COIN_HERO, DICE_HERO } from "../../lib/tones";
import { DiceRoll } from "../reveal/DiceRoll";
import { StagePanel } from "./StagePanel";

export function CoinPanel() {
  const { phase, outcome, go } = useInstant<ToolOutcome>();
  const run = () => go(flipCoin(), { kind: "tool", title: "Heads or Tails", category: "heads-or-tails" });
  const tails = phase === "done" && outcome?.result === "TAILS";
  return (
    <StagePanel testId="home-coin-panel" title="Heads or Tails" to="/tools/heads-or-tails" stageClass="bg-[#1a1006]"
      phase={phase} result={outcome ? `${outcome.result}!` : undefined} onGo={run} goLabel="Flip it" idleHint="Tap the coin or hit flip"
      stage={
        <img key={phase === "counting" ? Date.now() : "still"} src={COIN_HERO} alt="Gold coin"
          className={`h-full w-auto rounded-2xl object-cover [mask-image:radial-gradient(circle,black_55%,transparent_72%)] ${phase === "counting" ? "animate-coinspin" : ""} ${tails ? "-scale-x-100 saturate-50 brightness-110" : ""}`} />
      } />
  );
}

export function DicePanel() {
  const { phase, outcome, go } = useInstant<ToolOutcome>();
  const run = () => go(rollDice(1), { kind: "tool", title: "Roll the Dice", category: "roll-the-dice" });
  return (
    <StagePanel testId="home-dice-panel" title="Roll the Dice" to="/tools/roll-the-dice" stageClass="bg-[#0b1430]"
      phase={phase} result={outcome?.result} onGo={run} goLabel="Roll it" idleHint="Tap the die or hit roll"
      stage={phase === "done" && outcome ? (
        <div className="scale-125"><DiceRoll values={outcome.animValue} fast={false} /></div>
      ) : (
        <img src={DICE_HERO} alt="Game die" className={`h-full w-auto object-cover [mask-image:radial-gradient(circle,black_55%,transparent_72%)] ${phase === "counting" ? "animate-shake" : ""}`} />
      )} />
  );
}
